"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ElementAttributeImageSwitcher_1 = __importDefault(require("@web/common/ElementAttributeImageSwitcher"));
const ScreenSize_1 = __importDefault(require("@web/common/ScreenSize"));
function setupLazyLoadImage(embla) {
    const imageElements = Array.from(embla.rootNode().querySelectorAll('.embla-lazy-load-img'));
    function loadImageInView(index) {
        const imageElement = imageElements[index];
        if (imageElement === undefined) {
            return;
        }
        const isBackground = imageElement.tagName !== 'IMG';
        ElementAttributeImageSwitcher_1.default.switch(imageElement, isBackground, ScreenSize_1.default.isSmallScreen());
    }
    function loadImagesInView() {
        embla.slidesInView().forEach(loadImageInView);
    }
    embla.on('slidesInView', loadImagesInView);
}
exports.default = setupLazyLoadImage;
